import { ItemList } from '../../UI/Cube/types'
import homeItems from './home/items'
import testItems from './gifTest/items'
import parteitagItems from './parteitag/items'
import tvItems from './tv/items'
import getKandiItems from './kandi/getKandiItems'
import { useEffect, useState } from 'react'

export enum PageType {
  HOME,
  KANDI,
  TEST,
  PARTEITAG,
  TV,
}

const useCubeItems = (pageType: PageType, id?: string): ItemList => {
  const [items, setItems] = useState<ItemList>(null)

  useEffect(() => {
    const getItems = async () => {
      if (pageType === PageType.HOME) {
        setItems(homeItems)
      } else if (pageType === PageType.TEST) {
        setItems(testItems)
      } else if (pageType === PageType.PARTEITAG) {
        setItems(parteitagItems)
      } else if (pageType === PageType.TV) {
        setItems(tvItems)
      } else if (pageType === PageType.KANDI) {
        const idTrimmed = id.trim().toLowerCase()
        const kandiItems = await getKandiItems(idTrimmed)
        setItems(kandiItems || parteitagItems)
      }
    }
    if (!items) {
      getItems()
    }
  }, [pageType, id, items])

  return items
}

export default useCubeItems
